export const normalizeAmount = amount => {
  if (typeof amount === "number") {
    return amount;
  }

  if (typeof amount === "string") {
    const cleanAmount = amount.replace(/[^\d.,]/g, "");
    const normalizedAmount = cleanAmount.replace(",", ".");
    const numericAmount = parseFloat(normalizedAmount);
    return Math.round(numericAmount * 100);
  }

  return 0;
};
